'use strict';


var angular:angular.IAngularStatic =  require('angular');
import {Component,Inject} from 'ng-metadata/core';

import serviceProviders, { ModelService } from './model.service';
//your imports go here
var beautify = require("json-beautify");

@Component({
    selector: 'prm-model',
    templateUrl: 'components/infra/dataStructures/model/model.html',
})


export class PrmModel{
    private entry: string = '';
    private bulk: string = '';
    private entry2: string = '';
    private index: string = '';
    constructor(private modelService: ModelService,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService) {
        if($stateParams['active']) {
            this.modelService.active = $stateParams['active'];
        }
        if($stateParams['entry']) {
            this.entry = $stateParams['entry'];
        }

        if($stateParams['bulk']) {
            this.bulk = $stateParams['bulk'];
        }

        if($stateParams['entry2']) {
            this.entry2 = $stateParams['entry2'];
        }

        if($stateParams['index']) {
            this.index = $stateParams['index'];
        }
        console.log($stateParams['entry']);
    }

    public splitToArray(array){
        return array.split(',');
    }
    public isJsonArray(element){
        return angular.isArray(element);
    }

    public beautifyJson(json){
        if(angular.isObject(json)){
            return beautify(json, null, 2, 100);
        }else{
            if(angular.isArray(json)){
                return json.map((element)=>{
                    return beautify(element, null, 2, 100);

                })
            }
        }
    }
    get active(){
        this.modelService.checkActive();
        return this.modelService.active;
    }

    set active(active){
        this.modelService.active = active;
    }


    get model(){
        if(this.index){
            let json = {};
            json[this.entry] = this.modelService.modelInstance[this.entry][this.bulk][this.entry2][this.index];
            return json;
        }

        if(this.bulk){
            let json = {};
            json[this.entry] = this.modelService.modelInstance[this.entry][this.bulk];
            return json;

        }

        if(this.entry){
            let json = {};
            json[this.entry] = this.modelService.modelInstance[this.entry];
            return json;
        }


        return this.modelService.modelInstance;
    }




}


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/dataStructures/model/model.directive.ts